import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold text-primary mb-8">Privacy Policy</h1>
          <div className="mb-6">
            <p className="text-gray-600 mb-4"><strong>Effective Date:</strong> June 1, 2025</p>
            <p className="text-gray-700 mb-4">At Ongroom, we value your privacy and are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, share, and safeguard your data when you use our mobile application or services.</p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Information We Collect</h2>
            <p className="text-gray-700 mb-4">We collect the following categories of information:</p>
            
            <div className="mb-4">
              <h3 className="text-xl font-medium text-gray-800 mb-2">Personal Information:</h3>
              <ul className="list-disc pl-8 text-gray-700 space-y-1">
                <li>Full Name</li>
                <li>Gender</li>
                <li>Phone Number</li>
                <li>Email Address</li>
              </ul>
            </div>
            
            <div className="mb-4">
              <h3 className="text-xl font-medium text-gray-800 mb-2">Authentication Information:</h3>
              <ul className="list-disc pl-8 text-gray-700 space-y-1">
                <li>Google Sign-In details (as authorized)</li>
                <li>Phone number verification through OTP</li>
              </ul>
            </div>
            
            <div className="mb-4">
              <h3 className="text-xl font-medium text-gray-800 mb-2">Address and Location:</h3>
              <ul className="list-disc pl-8 text-gray-700 space-y-1">
                <li>Full address for service delivery at home</li>
                <li>Geolocation data (only with permission)</li>
              </ul>
            </div>
            
            <div className="mb-4">
              <h3 className="text-xl font-medium text-gray-800 mb-2">Service Usage Data:</h3>
              <ul className="list-disc pl-8 text-gray-700 space-y-1">
                <li>Type of service booked (e.g., haircut, facial, waxing, etc.)</li>
                <li>Booking time and date</li>
                <li>Service location (salon or home)</li>
              </ul>
            </div>
            
            <div className="mb-4">
              <h3 className="text-xl font-medium text-gray-800 mb-2">Device & Technical Information:</h3>
              <ul className="list-disc pl-8 text-gray-700 space-y-1">
                <li>IP address</li>
                <li>Device type, OS, browser type</li>
                <li>App usage patterns and crash logs</li>
              </ul>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. How We Use Your Information</h2>
            <p className="text-gray-700 mb-4">Your data is used to:</p>
            <ul className="list-disc pl-8 text-gray-700 space-y-2">
              <li>Process and confirm bookings for grooming and beauty services.</li>
              <li>Match users with suitable salons or professionals.</li>
              <li>Facilitate at-home service by verifying addresses and gender-based service rules.</li>
              <li>Notify users of bookings, updates, offers, and promotions.</li>
              <li>Enhance app functionality and user experience via analytics.</li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Sharing Your Information</h2>
            <p className="text-gray-700 mb-4">We may share your information in the following cases:</p>
            <ul className="list-disc pl-8 text-gray-700 space-y-2">
              <li>With partnered salons or service professionals to complete your booking.</li>
              <li>With payment gateways for secure transaction processing.</li>
              <li>With law enforcement agencies if mandated by law.</li>
              <li>With analytics and cloud service providers to maintain performance.</li>
            </ul>
            <p className="text-gray-700 mt-4">We do not sell or rent your personal data to third parties.</p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Data Retention and Security</h2>
            <ul className="list-disc pl-8 text-gray-700 space-y-2">
              <li>Your data is retained only as long as necessary to provide services.</li>
              <li>We implement secure storage, encryption, and secure API integrations.</li>
              <li>Despite our efforts, no system is 100% immune to breach; by using Ongroom, you acknowledge this.</li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Your Rights</h2>
            <ul className="list-disc pl-8 text-gray-700 space-y-2">
              <li>You can view and update your profile anytime.</li>
              <li>You may request deletion of your data and account by contacting us.</li>
              <li>EU users are entitled to GDPR rights including data access and portability.</li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Use of Cookies and Analytics Tools</h2>
            <p className="text-gray-700">Ongroom uses cookies, session storage, and analytics tools (e.g., Google Analytics) to understand behavior and improve the app.</p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Changes to This Privacy Policy</h2>
            <p className="text-gray-700">We may revise this Privacy Policy at any time. Updated policies will be posted in the app and notified to users.</p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Contact Information</h2>
            <p className="text-gray-700">Email: <a href="mailto:support@ongroom.com" className="text-primary hover:underline">support@ongroom.com</a></p>
          </div>

          <div className="mt-12 pt-6 border-t border-gray-200">
            <Link to="/" className="text-primary hover:underline flex items-center">
              <i className="ri-arrow-left-line mr-2"></i> Back to Home
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;